<div class="flex flex-col w-full h-full">
  <app-page-header>
    <div>Berichte</div>
    <!-- Suche, Ansichtsumschalter und Filter in der Topnav, analog zu den Tasks. -->
    @if (!isEmptyState) {
      <div class="flex flex-row items-center justify-end gap-4 whitespace-nowrap">
        <div class="w-[268px] min-w-[140px]">
          <bic-input [(ngModel)]="searchText" (ngModelChange)="search()" [iconStart]="faMagnifyingGlass"
                     placeholder="Berichte suchen..."></bic-input>
        </div>
        <bic-button-group (valueChange)="onViewModeChange($event)" [value]="viewMode">
          <bic-button-group-item ariaLabel="Tabelle" value="table">
            <fa-icon [icon]="faTable" class="text-svg-16"></fa-icon>
          </bic-button-group-item>
          <bic-button-group-item ariaLabel="Karten" value="cards">
            <fa-icon [icon]="faGrid2" class="text-svg-16"></fa-icon>
          </bic-button-group-item>
        </bic-button-group>
        <app-bic-filter (filtersChange)="onFiltersChange($event)" [filtersConfig]="filterConfig"></app-bic-filter>
      </div>
    }
  </app-page-header>

  <!-- isolate: eigener Stacking Context, damit die sticky Tabellen-Kopfzeile (CDK setzt per Inline-Style
       z-index 100) nicht ueber den Dropdowns der Topnav (app-page-header, z-10) liegt. -->
  <div class="flex flex-row w-full h-full p-6 overflow-hidden isolate">
    <div class="w-full h-full flex flex-col overflow-hidden">
      @if (isEmptyState) {
        <app-empty-state [icon]="faCircleInfo" class="flex-1" message="Noch keine Berichte vorhanden">
          <bic-button (onClick)="routeToAllInCheck()" buttonType="white">
            All-In Check
            <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
          </bic-button>
        </app-empty-state>
      } @else {
        <!-- Ohne Rahmen um den Inhalt; in der Tabellenansicht traegt nur die Tabelle selbst den Rahmen,
             in der Kartenansicht jede Karte. -->
        <div class="w-full h-full overflow-hidden flex flex-col gap-4">
          <div [class]="viewMode === 'table'
                  ? 'flex-1 min-h-0 overflow-hidden border border-gray-200 rounded-lg flex flex-col'
                  : 'flex-1 min-h-0 overflow-hidden flex flex-col'">
          @if (loading) {
            <div class="flex flex-col flex-1 justify-center items-center py-16">
              <div class="flex flex-row items-center gap-2">
                <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                <span class="text-sm font-medium text-gray-500">Berichte werden geladen...</span>
              </div>
            </div>
          } @else if (filteredRows.length === 0) {
            <div class="flex flex-col flex-1 justify-center items-center py-16">
              <span class="text-sm font-medium text-gray-500">Keine Berichte gefunden</span>
            </div>
          } @else if (viewMode === 'table') {
            <div class="w-full flex-1 overflow-y-auto">
              <table (matSortChange)="search()" [dataSource]="visibleRows" [trackBy]="trackByRowId" cdk-table class="w-full"
                     matSort matSortActive="date" matSortDirection="desc">
                <ng-container cdkColumnDef="check">
                  <th *cdkHeaderCellDef cdk-header-cell class="w-[37%]" mat-sort-header>Check</th>
                  <td *cdkCellDef="let element" [title]="element.name" cdk-cell>{{ element.name }}</td>
                </ng-container>

                <ng-container cdkColumnDef="myChecks">
                  <th *cdkHeaderCellDef cdk-header-cell class="w-[17.5%]" mat-sort-header>myChecks</th>
                  <td *cdkCellDef="let element" cdk-cell>
                    <app-report-mychecks-badge [row]="element" class="flex max-w-full"></app-report-mychecks-badge>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="files">
                  <th *cdkHeaderCellDef cdk-header-cell class="w-[8%]" mat-sort-header>Dateien</th>
                  <td *cdkCellDef="let element" cdk-cell>
                    <app-report-files-badge [files]="element.files" class="flex max-w-full"></app-report-files-badge>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="date">
                  <th *cdkHeaderCellDef cdk-header-cell class="w-[11%]" mat-sort-header>Datum</th>
                  <td *cdkCellDef="let element" cdk-cell>{{ element.check.checkDate | date:'dd.MM.yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container cdkColumnDef="checker">
                  <th *cdkHeaderCellDef cdk-header-cell class="w-[12.5%]" mat-sort-header>Prüfer*in</th>
                  <td *cdkCellDef="let element" [title]="element.check.checkerName" cdk-cell>{{ element.check.checkerName }}</td>
                </ng-container>

                <ng-container cdkColumnDef="state">
                  <th *cdkHeaderCellDef cdk-header-cell class="w-[10%]" mat-sort-header>Status</th>
                  <td *cdkCellDef="let element" cdk-cell>
                    <bic-badge [type]="element.badgeType">{{ element.statusLabel }}</bic-badge>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="actions">
                  <th *cdkHeaderCellDef cdk-header-cell class="!w-[52px] !p-0"></th>
                  <td *cdkCellDef="let element" cdk-cell class="!w-[52px] !p-0">
                    <ng-container *ngTemplateOutlet="rowMenu; context: {$implicit: element}"></ng-container>
                  </td>
                </ng-container>

                <tr *cdkHeaderRowDef="displayedColumns; sticky: true" cdk-header-row></tr>
                <tr (auxclick)="openCheck(row.check, $event)"
                    (click)="openCheck(row.check, $event)"
                    *cdkRowDef="let row; columns: displayedColumns;"
                    cdk-row></tr>
              </table>

              <ng-container *ngTemplateOutlet="loadMoreButton"></ng-container>
            </div>
          } @else {
            <div class="w-full flex-1 overflow-y-auto">
              <div class="flex flex-col gap-6">
                @for (group of visibleGroups; track group.key) {
                  <section class="flex flex-col gap-3">
                    <h2 class="text-sm font-medium text-gray-900">{{ group.label }}</h2>
                    <div class="grid gap-6 report-card-grid">
                      @for (row of group.items; track row.id) {
                        <app-report-card (open)="openCheck(row.check, $event)" [menu]="rowMenu" [row]="row"></app-report-card>
                      }
                    </div>
                  </section>
                }
              </div>

              <ng-container *ngTemplateOutlet="loadMoreButton"></ng-container>
            </div>
          }
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Ein Menue fuer Tabelle und Karte (Figma "Dropdown"): bei laufender Pruefung ersetzt "Abbrechen"
     den Eintrag "Oeffnen". -->
<ng-template #rowMenu let-row>
  <button (click)="$event.stopPropagation()"
          [bicDropdownTrigger]="actionsDropdown"
          class="flex items-center justify-center w-10 h-[38px] rounded-lg hover:bg-gray-100 transition-colors shrink-0 mx-auto"
          title="Aktionen">
    <fa-icon [icon]="faEllipsisVertical" class="text-svg-16 text-gray-900"></fa-icon>
  </button>
  <bic-dropdown #actionsDropdown [dropdownPlacement]="'bottom-end'">
    @if (row.canCancel) {
      <bic-dropdown-element (click)="cancelReport($event, row.check)"
                            [class.opacity-50]="actionInProgress === row.id"
                            [class.pointer-events-none]="actionInProgress === row.id">
        <div class="flex flex-row items-center gap-2 text-sm text-red-600">
          <fa-icon [icon]="faXmark" class="text-svg-16 w-4"></fa-icon>
          <span>Abbrechen</span>
        </div>
      </bic-dropdown-element>
    } @else {
      <bic-dropdown-element (click)="openCheck(row.check, $event)"
                            [class.opacity-50]="!row.canOpen"
                            [class.pointer-events-none]="!row.canOpen">
        <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
          <fa-icon [icon]="faArrowUpRightFromSquare" class="text-svg-16 text-gray-900 w-4"></fa-icon>
          <span>Öffnen</span>
        </div>
      </bic-dropdown-element>
    }
    <bic-dropdown-element (click)="openLogView($event, row.check)"
                          [class.opacity-50]="!row.hasLog"
                          [class.pointer-events-none]="!row.hasLog">
      <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
        <fa-icon [icon]="faClipboardList" class="text-svg-16 text-gray-900 w-4"></fa-icon>
        <span>Prüflauf Log</span>
      </div>
    </bic-dropdown-element>
    @if (row.status === 'ARCHIVED' || row.check.archived) {
      <bic-dropdown-element (click)="unarchiveReport($event, row.check)"
                            [class.opacity-50]="actionInProgress === row.id"
                            [class.pointer-events-none]="actionInProgress === row.id">
        <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
          <fa-icon [icon]="faArrowRotateRight" class="text-svg-16 text-gray-900 w-4"></fa-icon>
          <span>Wiederherstellen</span>
        </div>
      </bic-dropdown-element>
    } @else {
      <bic-dropdown-element (click)="archiveReport($event, row.check)"
                            [class.opacity-50]="actionInProgress === row.id"
                            [class.pointer-events-none]="actionInProgress === row.id">
        <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
          <fa-icon [icon]="faBoxArchive" class="text-svg-16 text-gray-900 w-4"></fa-icon>
          <span>Archivieren</span>
        </div>
      </bic-dropdown-element>
    }
  </bic-dropdown>
</ng-template>

<ng-template #loadMoreButton>
  @if (hasMore) {
    <div [class.border-t]="viewMode === 'table'" class="w-full flex justify-center py-3 border-gray-200">
      <bic-button (onClick)="loadMore()" [disabled]="isLoadingMore" buttonType="white">
        <fa-icon [class.animate-spin]="isLoadingMore"
                 [icon]="isLoadingMore ? faSpinnerThird : faChevronDown"
                 class="mr-2"></fa-icon>
        {{ isLoadingMore ? 'Lädt...' : 'Mehr laden (' + remainingCount + ')' }}
      </bic-button>
    </div>
  }
</ng-template>
